import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { AddOrEditForm } from '../../components/AddOrEditForm';
import {
  AlertsModalType,
  DestinationsFormValues,
  getDefaultDestinationsFormValues,
  useAlertsModalContext,
  withDestinationsFormProvider,
} from '../../context';
import { useEditWebhook, useGetWebhook } from '../../hooks';
import { EditOrDeleteWebhookModalProps } from '../../types';

export const EDIT_WEBHOOK_MODAL_TEST_ID = 'edit-webhook-modal';
export const EDIT_WEBHOOK_BUTTON_TEST_ID = 'edit-webhook-button';

export const EditWebhookModal = withDestinationsFormProvider<EditOrDeleteWebhookModalProps>(
  ({ webhookId }) => {
    const { closeModal } = useAlertsModalContext();
    const { editWebhook, isLoading } = useEditWebhook(webhookId, () =>
      closeModal(AlertsModalType.EditWebhookModal),
    );

    const {
      handleSubmit,
      formState: { errors, dirtyFields },
      reset,
    } = useFormContext<DestinationsFormValues>();

    const { webhook, loading: isFetchingWebhook } = useGetWebhook(webhookId);

    useEffect(() => {
      if (!isFetchingWebhook) {
        reset(getDefaultDestinationsFormValues(webhook));
      }
    }, [webhook, reset, isFetchingWebhook]);

    return (
      <Modal
        withPortal
        isModalOpen
        onClose={() => closeModal(AlertsModalType.EditWebhookModal)}
        id={EDIT_WEBHOOK_MODAL_TEST_ID}
        size={MODAL_SIZES.MEDIUM}
        variant={MODAL_VARIANTS.DEFAULT}
      >
        <ModalHeader>Edit webhook</ModalHeader>

        <ModalBody>
          <AddOrEditForm />
        </ModalBody>

        <ModalFooter>
          <PrimaryButton
            data-test={EDIT_WEBHOOK_BUTTON_TEST_ID}
            isDisabled={!isEmpty(errors) || isFetchingWebhook}
            isLoading={isLoading}
            onClick={handleSubmit((values) => editWebhook(values, dirtyFields))}
            size={BUTTON_SIZES.LARGE}
          >
            Save webhook
          </PrimaryButton>
        </ModalFooter>
      </Modal>
    );
  },
);
